import { render } from "./cabinetBusyness.vue?vue&type=template&id=79d3664e"
import script from "./cabinetBusyness.vue?vue&type=script&lang=js"
export * from "./cabinetBusyness.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__